import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="section bg-white">
      <div className="container">
      </div>
    </section>
  );
};

export default About;